module.exports = __webpack_public_path__ + "static/media/15.ef1694ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/15.jpg
// module id = 276
// module chunks = 0